import { fetch as fetchPolyfill } from 'whatwg-fetch';
import ConnexPayService from './ConnexPayService';

export default class ConnexPay3ds {
    private connexPayService: ConnexPayService
    public constructor(
        private readonly transactionToken: string,
        private readonly continueBookingUrl: string,
        private readonly triggerCheckStatusUrl: string,
        private readonly triggerCompletionUrl: string,
        private state: string,
        private acceptHeader: string,
        private redirectUrl: string,
        private readonly returnUrl: string
    ) {

        this.connexPayService = new ConnexPayService()
    }
    private ajaxPool: any[] = []
    public start(): void {
        if (document.forms["3dsFingerprintForm"]) {
            document.forms["3dsFingerprintForm"].submit();
        }

        if (document.forms["threeDsAuthenForm"]) {
            document.forms["threeDsAuthenForm"].submit();
        }

        if (this.state === 'pending') {
            this.ajaxPool.push(this.triggerCheckStatusUrl);
            this.createPolling()
        }

        if (this.state === 'fail') {
            window.location.href = `${this.returnUrl}`;
        }
    }

    private createPolling = () => {
        //an interval to handle the queue
        setInterval(() => {
            //nothing in the pool so do nothing
            if (this.ajaxPool.length < 1) return;
            this.callCheckStatus(this.ajaxPool[0]);
        }, 5000);
    }

    private callCheckStatus = (option: any) => {
        fetchPolyfill(option)
            .then((response) => response.json())
            .then(response => {
                if (response.status === 'success') {
                    this.ajaxPool.pop()
                    this.completeTransaction()
                } else if (response.status === 'declined') {
                    this.ajaxPool.pop()
                    window.location.href = `${this.continueBookingUrl}&transactionToken=${response.guid}`;
                } else if (response.status === 'pending' && response.isRdirectToChallenge) {
                    window.location.reload();
                } else if(response.status === 'fail') {
                    window.location.href = `${this.returnUrl}`;
                }
            })
    }

    private completeTransaction = () => {
        const browserInfo = this.connexPayService.getBrowserInfo(this.acceptHeader, this.redirectUrl)
        const browserJson = JSON.stringify(browserInfo)
        const data = JSON.stringify({
            transactionToken: this.transactionToken,
            context: {
                browserInfo: browserJson
            }
        })
        fetchPolyfill(`${this.triggerCompletionUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: data
        })
            .then((response) => response.json())
            .then((response) => {
                window.location.href = `${this.continueBookingUrl}&transactionToken=${response.guid}`;
            });
    }

}